























































import AppCard from '~/components/AppCard.vue'
import AddClinicalTrialDialog from '~/components/clinical-trial/AddClinicalTrialDialog.vue'
import AddClinicalTrialUserInvite from '~/components/clinical-trial/AddClinicalTrialUserInvite.vue'
import { Role } from '../../../shared/Role'
import Vue from 'vue'
import { sortAlphabetically, filterList } from '../../helper/Utilities'

export default Vue.extend({
  components: {
    AppCard,
    AddClinicalTrialDialog,
    AddClinicalTrialUserInvite,
  },
  data: () => ({
    title: 'Clinical Trials',
    clinicalTrials: [],
    search: '',
    Role,
  }),
  mounted() {
    this.loadClinicalTrials()
  },
  computed: {
    subtitle() {
      return 'An overview of your clinical trials'
    },
    noTrialsAlert() {
      return 'You currently have no clinical trials.'
    },
    filteredClinicalTrials(): any[] {
      return sortAlphabetically(
        filterList(this.clinicalTrials, this.search),
        'name'
      )
    },
  },
  methods: {
    async loadClinicalTrials() {
      let res =
        this.$auth.user?.role === Role.Admin
          ? await this.$axios.get(`clinical-trial/all`)
          : await this.$axios.get(`clinical-trial/administeredTrials`)
      this.clinicalTrials = res.data
    },
    async handleEditClinicalTrial(id: string) {
      await this.$router.push(`/clinical-trial/${id}`)
    },
  },
})
